import React from 'react';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import RateCodeManagementPage from '~/components/Cruises/pages/RateCodeManagement/RateCodeManagementPage';

import { CruiseLine } from '~/services/cruises/CruiseLineService';

interface Props {
  cruiseLine: CruiseLine;
  isOpen: boolean;
  onClose: () => void;
}

function RateGroupingRatesModal({ cruiseLine, isOpen, onClose }: Props) {
  return (
    <>
      {cruiseLine && (
        <Dialog open={isOpen} onClose={onClose} maxWidth="xl" fullWidth>
          <DialogTitle>Cached rate codes</DialogTitle>
          <DialogContent>
            <RateCodeManagementPage disableCreate initialVendorFilter={cruiseLine} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default RateGroupingRatesModal;
